import React, { useState } from 'react'
import { Button, Grid, GridCell, TabMenu, TabMenuButton, View } from 'oio-react'
import Helmet from 'react-helmet'
import { LAYOUT_BOX } from 'config/constants/ui'
import { useOrganization, useUserList } from 'src/core/graphql/hooks'
import UserListItemDetailsCard from 'src/sites/kits/People/components/UserListItemDetailsCard'
import { EmptyContentBlock, LayoutContainer, LayoutContainerInner, Title, Titlebar }
   from 'src/sites/kits/UI'
import { useGlobalState } from 'src/sites/state'

const FILTER_BY_MEMBERS = 'primary'
const FILTER_BY_ADMINS = 'admin'

const People = () => {
   const [activeRoleType, setActiveRoleType] = useState(FILTER_BY_MEMBERS)
   const { theme } = useGlobalState()
   const isBoxGL = theme.tmpGlobalLayout === LAYOUT_BOX
   const targetType = 'organization'
   const targetId = 'current'

   const { organization } = useOrganization()
   const { userList, loading, fetchMore } = useUserList({
      userRelationshipFilter: {
         entityType: targetType,
         entityId: targetId,
         hasRoleParticipantElement: {
            roleType: activeRoleType,
            status: 'active'
         }
      },
      withRelationship: false,
      withRelationshipEntityType: targetType,
      withRelationshipEntityId: targetId
   })

   const handleLoadMore = () => {
      fetchMore({
         variables: {
            start: userList.listInfo.nextCursor
         },
         updateQuery: (prevResult, { fetchMoreResult }) => {
            if (!fetchMoreResult) {
               return prevResult
            }

            return {
               ...prevResult,
               userList: {
                  ...prevResult.userList,
                  items: [
                     ...prevResult.userList.items,
                     ...fetchMoreResult.userList.items
                  ],
                  listInfo: fetchMoreResult.userList.listInfo
               }
            }
         }
      })
   }

   return (
      <LayoutContainer maxWidth="1200px">
         <LayoutContainerInner>
            <Helmet title={`People | ${organization.name}`} />
            <Titlebar
               size="lg"
               paddingLeft={theme.tmpAppOuterPaddingHorizontal}
               paddingRight={theme.tmpAppOuterPaddingHorizontal}>
               <Title color={theme.tmpContentTitleColor}>
                  People
               </Title>
            </Titlebar>
            <View
               display="flex"
               flexFlow={isBoxGL
                  ? 'column[a-d] row[e-f]'
                  : 'column[a-c] row[d-f]'
               }
               paddingHorizontal={theme.tmpAppOuterPaddingHorizontal}>
               <View
                  flex="1 1 auto"
                  height="100%"
                  minHeight="100vh">
                  <View
                     float="left"
                     width="100%"
                     borderBottom={`1px solid ${theme.tmpContentLineColor}`}>
                     <TabMenu
                        buttonPaddingHorizontal="0px"
                        buttonSpacing="20px"
                        buttonSize="xl"
                        buttonTextSize="2"
                        highlightColor="#222">
                        <TabMenuButton
                           isActive={activeRoleType === FILTER_BY_MEMBERS}
                           onClick={() => setActiveRoleType(FILTER_BY_MEMBERS)}
                           name="Community Members"
                        />
                        <TabMenuButton
                           isActive={activeRoleType === FILTER_BY_ADMINS}
                           onClick={() => setActiveRoleType(FILTER_BY_ADMINS)}
                           name="Admins"
                        />
                     </TabMenu>
                  </View>
                  {userList.items.length === 0 && (
                     <EmptyContentBlock
                        message="No users to show here yet"
                     />
                  )}
                  <View
                     float="left"
                     width="100%"
                     paddingVertical={theme.tmpSpacingTop}>
                     {userList.items.length > 0 && (
                        <Grid columns="1[a-b] 2[c] 3[d] 3[e-f]" spacing="10px[a-b] 30px[c-f]">
                           {userList.items.map(user => (
                              <GridCell key={user.id}>
                                 <UserListItemDetailsCard
                                    id={user.id}
                                    avatarMedia={user.avatarMedia}
                                    avatarSize="30px[a-d] 40px[e-f]"
                                    badges={user.badges}
                                    fullName={user.fullName}
                                    organization={user.organization}
                                    position={user.position}
                                 />
                              </GridCell>
                           ))}
                        </Grid>
                     )}
                     {userList.listInfo.hasNext && (
                        <View
                           float="left"
                           width="100%"
                           display="flex"
                           justifyContent="center"
                           borderTop="1px solid #eee"
                           margin="20px 0px"
                           padding="20px 0px">
                           <Button
                              color="#eee"
                              textColor="#333"
                              size="xs"
                              onClick={handleLoadMore}
                              name="Load More"
                              mode={loading ? 'loading' : 'normal'}
                           />
                        </View>
                     )}
                  </View>
               </View>
            </View>
         </LayoutContainerInner>
      </LayoutContainer>
   )
}

export default People
